import { ChatChannelQuickMessageInput } from '@modules/chat-channel-text/ChatChannelQuickMessageInput';
import { useEditor } from '@modules/editor';
import { Box } from '@mui/material';
import { Loading } from 'src/components/Loading/Loading';
import { DirectMessageControl } from './useDirectMessageControl';

export const UserProfileShortSendMessage = ({
  dmControl,
}: {
  dmControl: DirectMessageControl;
}) => {
  const { handleSendMessage, editorConfig, isLoading } = dmControl;

  const { editor } = useEditor(editorConfig, []);

  if (!editor) return null;

  return (
    <Box sx={{ position: 'relative' }}>
      <ChatChannelQuickMessageInput
        editor={editor}
        onTextMessage={handleSendMessage}
      />
      {isLoading && <Loading />}
    </Box>
  );
};
